import { http } from '../../http';

export default {
  getBookSlug(slug) {
    return http.get(`/books/${slug}`);
  },
};
